import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
// import { environment } from '../../../environments/environment.local';
import { api } from '../../shared/common';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.authority,
    redirectUrl: environment.uiUrl + '/auth/login', // || window.location.origin,
    postLogoutRedirectUri: environment.uiUrl + '/auth', // || window.location.origin,
    clientId: environment.cognitoClientId,
    scope: 'openid email',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    secureRoutes: [api],
  },
};

@Injectable()
export class MyStorageService implements AbstractSecurityStorage {
  read(key: string): string | null {
    return localStorage.getItem(key);
  }

  write(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
